<template>
  <div class="page-container pt-3 pb-4 video-page" v-if="shiur">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="shiur-video-container">
              <jwvideo
                :link="shiur.url_video_download || shiur.url_download"
                :image="videoThumbnail"
                :playerId="'video-player-1'"
                :shiurId="shiur.id"
                :autoStart="true"
                :startPosition="shiur.history ? shiur.history.duration_played : null"
              ></jwvideo>
            </div>

            <div class="text-primary mt-3">Shiur# {{ shiur.id + offset }}</div>
            <ShasDescription v-if="shiur.lecturer_id" :shiur="shiur" />
            <TorahDescription v-else :shiur="shiur" />

            <div v-if="shiur" class="my-3 d-flex action-btn-container">
              <play-btn class="mr-4 mr-md-2 position-relative" v-bind="actionProps"></play-btn>
              <download-btn class="mr-4 mr-md-2 position-relative" v-bind="actionProps"></download-btn>
              <share-btn
                class="mr-4 mr-md-2 position-relative"
                :url="share.url"
                :title="share.title"
                :description="share.description"
                :hashtags="share.hashtags"
              ></share-btn>
            </div>
            <div class="mb-4">
              <form @submit.prevent="sendComment" method="POST">
                <b-form-textarea v-model="newComment" :placeholder="$_t('KW:thoughtsOnShiur')" required></b-form-textarea>
                <button class="btn btn-primary mt-2 float-right">
                  {{ $_t('KW:comment') }}
                </button>
                <div class="clearfix"></div>
              </form>
              <div v-if="comments.length > 0">
                <div class="card my-4" v-for="comment in comments">
                  <div class="card-body">
                    <p>{{ comment.comment_text }}</p>
                    <div>
                      <strong>{{ comment.user.fullname }}</strong>
                      <button
                        v-if="$store.getters['auth/isLoggedIn'] && comment.can.delete"
                        @click="deleteComment(comment)"
                        class="ml-3 btn btn-sm btn-danger float-right"
                      >
                        {{ $_t('KW:delete') }}
                      </button>
                      <span class="float-right">{{ comment.created_at }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="row">
              <div class="mb-3 col-12 col-md-4 col-sm-6 col-lg-12 col-xl-6" v-for="row in suggestedShiurim">
                <div class="shiurim-card">
                  <shiurim-card :shiurim="row"></shiurim-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="$store.state.api.categories.length > 0">
          <CategoryListSingle
            :key="cat.id"
            :slug="cat.url_key"
            :showFilters="{ speaker: true }"
            :showPagination="false"
            :singleCategoryPage="false"
            v-for="cat in $store.state.api.categories"
            :singleCategoryUrl="cat.url_key"
            :perCategory="15"
            class="mb-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import video from '../partials/Video';
import { mapState } from 'vuex';
import ShiurimCardComponent from '../partials/ShiurimCard.vue';
import CategoryListSingle from '../torahShiurim/CategoryListSingle';
import downloadBtnComponent from '../partials/ActionButtons/downloadBtn.vue';
import playBtnComponent from '../partials/ActionButtons/playBtn.vue';
import shareBtnComponent from '../partials/ActionButtons/shareBtnSection.vue';
import ShasDescription from './shas_description.vue';
import TorahDescription from './torah_description.vue';

export default {
  metaInfo: function () {
    return {
      title: this.title,
      meta: [{ name: 'description', content: this.metaDescription }],
    };
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'videoPage',
  },
  components: {
    jwvideo: video,
    ShiurimCard: ShiurimCardComponent,
    CategoryListSingle: CategoryListSingle,
    downloadBtn: downloadBtnComponent,
    playBtn: playBtnComponent,
    ShasDescription,
    TorahDescription,
    shareBtn: shareBtnComponent,
  },
  data: function () {
    return {
      shiur: null,
      comments: [],
      newComment: '',
      allSuggestedShiurim: null,
      categories: null,
      categories_list: null,
      offset: parseInt(process.env.MIX_CALL_SYSTEM_OFFSET_SHIURIM) || 0,
      width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    };
  },
  created: function () {
    this.getData();
    this.getComments();
    this.$store.dispatch('api/loadCategories');
  },
  computed: {
    ...mapState({
      videoTrack: function (state) {
        return state.player.videoTrack;
      },
    }),
    title() {
      if (!this.shiur) return;
      let shiur = this.shiur;
      switch (shiur.type) {
        case 'shas':
          return shiur.masechta.name + ' ' + shiur.daf + ' by ' + shiur.lecturer.name;
        case 'torah':
          let name = /^[א-ת]/.test(shiur.name) ? `A ${shiur.name}` : shiur.name;
          return name + ' by ' + shiur.speaker.name;
        case 'mishna':
          return shiur.book.name + ' ' + shiur.mishna_chapter + ' ' + shiur.mishna_number + ' by ' + shiur.professor.name;
      }
    },
    metaDescription: function() {
      return this.title ? this.$_t('KW:site.metaWithName', { name: this.title }) : this.$_t('KW:site.metaWithoutName');
    },
    share() {
      console.log(this.$router.currentRoute);
      return {
        url: window.location,
        title: this.title,
        // description: 'Sample description',
        hashtags: 'shasilluminated',
      };
    },
    suggestedShiurim() {
      let limit = 6;
      if (this.width >= 992 && this.width < 1200) {
        limit = 3;
      }

      return this.allSuggestedShiurim ? this.allSuggestedShiurim.slice(0, limit) : [];
    },
    videoThumbnail() {
      if (!this.shiur) return;
      if (this.shiur.url_video_thumbnail) {
        return this.shiur.url_video_thumbnail;
      } else if (this.shiur.speaker && this.shiur.speaker.audio_thumbnail) {
        return this.shiur.speaker.audio_thumbnail.url;
      } else if (this.shiur.lecturer && this.shiur.lecturer.audio_thumbnail) {
        return this.shiur.lecturer.audio_thumbnail.url;
      }
      return '/static/img/audio-thumbnail.jpg';
    },
    actionProps() {
      return { shiurim: this.shiur, magidShiur: this.shiur.speaker, type: 'torah', hideText: true };
    },
  },
  watch: {
    '$route.params.id': function (id) {
      this.getData();
    },
  },
  methods: {
    scrollToVideoTop() {
      let yOffset = -80;
      if (this.width <= 1200) {
        yOffset = -100;
      }
      const element = document.querySelector('.video-page');
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y });
    },
    getData: function () {
      this.$http.get('/api/shiur/' + this.$route.params.id).then(response => {
        this.shiur = response.data;

        if (this.width >= 992) {
          this.$nextTick(this.scrollToVideoTop);
        }

        this.$http.get('/api/shiur/' + this.shiur.id + '/suggested-shiurim').then(response => {
          this.allSuggestedShiurim = response.data;
        });
      });
    },
    getComments: function () {
      this.$http.get('/api/comments?shiur_id=' + this.$route.params.id).then(response => {
        this.comments = response.data;
      });
    },
    sendComment: function () {
      if (this.$store.getters['auth/isLoggedIn']) {
        this.$http
          .post('/api/comments', {
            shiur_id: this.$route.params.id,
            comment_text: this.newComment,
          })
          .then(response => {
            this.newComment = '';
            this.comments.push(response.data.comment);
          });
      } else {
        this.$store.dispatch('auth/showModal');
      }
    },
    deleteComment: function (comment) {
      this.$http.delete('/api/comments/' + comment.id).then(response => {
        this.comments = this.comments.filter(c => c.id !== comment.id);
      });
    },
  },
};
</script>
<style lang="scss">
.video-page {
  .shiur-video-container {
    // height: 500px;
  }
  //.action-btn-container button {
  //  height: 30px;
  //  width: 30px;
  //  i.fa {
  //    font-size: 1rem !important;
  //  }
  //}
}
</style>
